// extracted by mini-css-extract-plugin
export default {"GateBody":"slider_GateBody__JTugQ","SettingsContainer":"slider_SettingsContainer__qoc76","Input":"slider_Input__fzCJz","Slider":"slider_Slider__p0ZSm","Label":"slider_Label__6toHm"};